import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './i18n/en.json';
import deTranslations from './i18n/de.json';

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      de: {
        translation: deTranslations
      }
    },
    lng: localStorage.getItem('app-language') || 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    // Enable nested translation keys (e.g., "incident.chat_agent.tools.send_communication")
    keySeparator: '.',
    nsSeparator: false, // We don't use namespaces
  });

// Listen for language changes from localStorage
const originalSetItem = localStorage.setItem;
localStorage.setItem = function(key, value) {
  originalSetItem.apply(this, arguments);
  if (key === 'app-language' && i18n.language !== value) {
    i18n.changeLanguage(value);
  }
};

export default i18n;

